import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <a
      href='https://jasonhanshaw.com'
      className='link footer__link'
    >
      &copy; {(new Date().getFullYear())} Jason Hanshaw
    </a>
  </footer>
)

export default Footer
